import React from "react";
import "./Home.css";

const HomeCaseStudy = () => {
  return (
    <section className="backdiv">
       <h2 className="main-title">Featured Case Study</h2>
      <div className="home-case-container ">

    
        <div className="home-case-content">
         

          <h3 className="home-case-head">
              Transforming an E-Commerce Platform with Scalable Architecture
          </h3>

          <div className="case-grid">
            
            <div className="home-case-card">
              <h4>Problem</h4>
              <p>Slow, outdated platform limiting growth.</p>
            </div>

            <div className="home-case-card">
              <h4> Solution</h4>
              <p>Modern scalable MERN architecture with optimized UX.</p>
            </div>

            <div className="home-case-card highlight">
              <h4>Result</h4>
              <ul>
                <li>Faster performance, higher conversions, and better customer experience.</li>
              </ul>
            </div>

          </div>
<div className="desk-btn">
  <a href="case-study/transforming-an-e-commerce-platform-with-scalable-architecture">
          <button className="main-btn">View Full Case Study →</button></a>
          </div>
        </div>

         <div className="case-imagediv">
          <div className="circle-visual">
            <div className="circles1 one"></div>
            <div className="circles1 two"></div>
            <div className="circles1 three"></div>
            <div className="case-img">
              <img 
    className="cover-img"
    src="./case-study1.webp"
   alt="vedastra"
   loading="lazy"
  />
            </div>
          </div>
        </div>


      </div>
    
<div className="mob-btn">
  <div className="d-flex align-items-center justify-content-center">
     <a href="case-study/transforming-an-e-commerce-platform-with-scalable-architecture">
        <button className="main-btn">View Full Case Study →</button></a>
        </div>
        </div>
    </section>
  );
};

export default HomeCaseStudy;